import { useState } from "react"

import { HelpCircle, ChevronDown, Check } from "lucide-react"
import "./FaqSection.scss"

const faqData = [
    {
        id: 1,
        question: "Is Jaak Tech a certified business?",
        answer:
            "Yes, we are MBE/DBE/SBE Certified (Certification No. 24-371), HUBZone Certified, and ISO 9001:2015 Certified.",
    },
    {
        id: 2,
        question: "Are you registered in SAM.gov?",
        answer: "Yes, we are registered and active in SAM.gov under Unique Entity ID D244FV1CHVP4.",
    },
    {
        id: 3,
        question: "What is your FEIN, Cage Code & DUNS number?",
        answer:
            "Our Federal Employer Identification Number (FEIN) is 86-1260376, Cage Code is 9FK10 & DUNS number is 124995677.",
    },
    {
        id: 4,
        question: "Do you have a government billing system?",
        answer: "We use compliant accounting systems to support government billing, including WAWF.",
    },
    {
        id: 5,
        question: "What is your policy for damaged shipments?",
        answer: "Report damaged shipments within 48 hours. We will file a claim and replace the damaged items.",
    },
    {
        id: 6,
        question: "What industries do you serve?",
        answer:
            "We serve federal and state government agencies, healthcare, education, finance, enterprise offices, and data centres.",
        list: [
            "Federal and state government agencies",
            "Healthcare organizations",
            "Educational institutions",
            "Financial services",
            "Enterprise offices",
            "Data centres",
        ],
    },
    {
        id: 7,
        question: "Can you provide past performance references?",
        answer: "Yes, we can provide past performance references upon request and with client consent.",
    },
]

const FaqSection = () => {
    const [expanded, setExpanded] = useState(false)

    const handleToggle = (panel) => {
        setExpanded(expanded === panel ? false : panel)
    }

    return (
        <section className="jk-faq">
            <div className="jk-faq__container">
                    <div className="jk-faq__header">
                        <span className="jk-section-label">
                            <HelpCircle size={16} />
                            FAQ's
                        </span>
                        <h2 className="jk-faq__title">
                            Have a Question?
                            <span className="jk-faq__title-highlight"> Look Here</span>
                        </h2>
                        <p className="jk-faq__subtitle">
                            Find answers to commonly asked questions about our certifications, services, and processes.
                        </p>
                    </div>

                    <div className="jk-faq__list">
                        {faqData.map((faq) => {
                            const panelId = `panel${faq.id}`
                            const isOpen = expanded === panelId

                            return (
                                <div
                                    key={faq.id}
                                    className={`jk-faq__item ${isOpen ? "is-open" : ""}`}
                                >
                                    <button
                                        className="jk-faq__question"
                                        onClick={() => handleToggle(panelId)}
                                        aria-expanded={isOpen}
                                        aria-controls={`faq-answer-${faq.id}`}
                                    >
                                        <span className="jk-faq__number">
                                            {String(faq.id).padStart(2, "0")}
                                        </span>
                                        <span className="jk-faq__question-text">
                                            {faq.question}
                                        </span>
                                        <ChevronDown size={20} className="jk-faq__chevron" />
                                    </button>
                                    <div
                                        className="jk-faq__answer"
                                        id={`faq-answer-${faq.id}`}
                                        role="region"
                                    >
                                        <div className="jk-faq__answer-inner">
                                            <p>{faq.answer}</p>
                                            {faq.list && (
                                                <ul className="jk-faq__answer-list">
                                                    {faq.list.map((item, idx) => (
                                                        <li key={idx}>
                                                            <Check size={16} className="jk-faq__check-icon" />
                                                            {item}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
            </div>
        </section>
    )
}

export default FaqSection
